import {
    HStack,
    Text,
} from "@chakra-ui/react";

import {
    Calendar,
    FileText,
} from "lucide-react";

const PolicyMetadata = ({
    updatedAt,
    version,
}) => {
    return (
        <HStack
            mt={3}
            gap={6}
            color="gray.500"
        >
            <HStack>
                <Calendar size={14} />

                <Text
                    fontSize="sm"
                >
                    Last Updated:
                    {" "}
                    {updatedAt}
                </Text>
            </HStack>

            <HStack>
                <FileText size={14} />

                <Text
                    fontSize="sm"
                >
                    Version
                    {" "}
                    {version}
                </Text>
            </HStack>
        </HStack>
    );
};

export default PolicyMetadata;